import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 400px;
  height: 400px;
  border-radius: 8px;
  
  background-color: #fff;
`;

export const Header = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;